export enum VatType {
    Zero,
    Incl,
    Excl,
}
